<template>
  <div>
    <div class="p-6 cursor-pointer w-full md:w-1/2 mx-auto">
      <span class="flex text-zt-dark-400" @click="$router.push({ name: 'salaryAdvances' })"
        data-vs-button="toPendingApproval">
        <zt-icon name="angle-left" class="pb-2 mt-1 pr-1" />
        <p>Volver</p>
      </span>
      <h1 class="fnot-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200 pb-6"> {{
        $t('message.salaryAdvanceForm.header') }}</h1>
      <div class="bg-white border border-gray-300 rounded hover:shadow-xl px-16 pt-16 w-full">
        <vue-loading background-color="rgba(0,0,0,0.0)" :active="loadingLicence" color="#4F41A3" :width="30" :height="30"
          :is-full-page="false" />
        <div class="flex text-zt-primary-600 pb-4 text-lg">
          <p class="text-2xl font-bold mb-8">{{ $t('message.salaryAdvanceForm.title') }}</p>
        </div>
        <div v-if="postResponseMessage !== ''" :class="errorClass"
          class="alert-company border rounded border-0 flex py-6 px-4 mb-6">
          <div class=" ml-1 mr-4 ml-4 w-4">
            <zt-icon :name="errorIcon" :class="errorIcon" class="info-icon" />
          </div>
          <p class="text-zt-base font-normal self-center">
            {{ postResponseMessage }}
          </p>
        </div>
        <div v-if="isManager" class="py-4">
          <p class="text-xl font-medium"> {{ $t("message.salaryAdvanceForm.requestUser") }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 pt-2 pb-4">{{ $t("message.salaryAdvanceForm.requestUserDescription")
          }}</p>
          <zt-autocomplete :label="$t('message.dashboard.colaboratorLabel')" :items="entries" v-model="requestUser"
            @search="(val) => searchApi(val)" apiSearch :searchCharacter="3" clearable
            noResultsText="No hay colaborador que coincidan con tu busqueda" outlined returnObject
            data-vs-autocomplete="approver" class="pl-2"></zt-autocomplete>
        </div>
        <div>
          <p class="text-xl font-medium"> {{$t( "message.salaryAdvanceForm.reason") }} </p>
          <p class="text-sm w-11/12 text-zt-dark-300 pb-4 pt-2"> {{ $t("message.salaryAdvanceForm.reasonDescription") }}
          </p>
          <zt-input outlined :label="$t('message.salaryAdvanceForm.reasonLabel')" maxlength="30" v-model="requestReason"
            data-vs-input="reason"></zt-input>
        </div>
        <div class="mt-4">
          <p class="text-xl font-medium"> {{ $t("message.salaryAdvanceForm.amount") }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 pb-4 pt-2">
            {{ $t("message.salaryAdvanceForm.amountDescription") }}
          </p>
          <zt-input outlined :label="$t('message.salaryAdvanceForm.amountLabel')" v-model.number="requestAmount"
            maxlength="9" @keypress="isNumber" data-vs-input="amount"></zt-input>
        </div>
        <div class="mt-4 ">
          <p class="text-xl font-medium ">{{ $t("message.salaryAdvanceForm.dateRange") }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 pb-4 pt-2">
            {{ $t("message.salaryAdvanceForm.dateRangeDescription") }}
            {{ $t("message.salaryAdvanceForm.dateRangePlannedDateRemember") }}
          </p>
          <vc-date-picker class="mx-auto shadowcustom text-zt-dark-300" color="indigo" data-vs-datepicker="datesRange"
            v-model="date" ref="datepicker" />

          <v-checkbox data-vs-check-box="select-document" v-model="salaryPaymentAdvance" color="primary" :value="1"
            :label="$t('message.licenseComponent.licenseBox.registerAnticipatePayment')"
            v-if="allowsSalaryPaymentAdvance" />
        </div>
        <div class="py-10 sm:p-10 flex sm:justify-end flex-wrap-reverse justify-center">
          <zt-button class="cancel-button text-base font-bold sm:pb-1" text @click="cancelRequestSalaryAdvance = true">{{
            $t("message.salaryAdvanceForm.btnCancel")
          }}</zt-button>
          <zt-button class="text-base font-bold ml-2 " @click="requestSalaryAdvance = true"
            :disabled="!isFormValid || isSubmitting">{{
              $t("message.salaryAdvanceForm.btnLoad")
            }}</zt-button>
        </div>
      </div>
    </div>
    <request-salary-advance-modal @update:requestSalaryAdvance="requestSalaryAdvance = $event" @confirm="postRequest"
      :requestSalaryAdvance="requestSalaryAdvance" :amount="requestAmount" :colaborator="requestUser"
      :reason="requestReason" :date="dateSelected" />
    <cancel-request-salary-advance-modal @update:cancelRequestSalaryAdvance="cancelRequestSalaryAdvance = $event"
      :cancelRequestSalaryAdvance="cancelRequestSalaryAdvance" />
  </div>
</template>

<script>
import Payroll from "@/apiClient/Payroll"
import Manager from '@/apiClient/Manager'
import moment from 'moment'
import RequestSalaryAdvanceModal from '../components/modals/RequestSalaryAdvanceModal.vue'
import CancelRequestSalaryAdvanceModal from '../components/modals/CancelRequestSalaryAdvanceModal .vue'


export default {
  name: "RequestSalaryAdvance",
  components: {
    RequestSalaryAdvanceModal, CancelRequestSalaryAdvanceModal
  },
  data() {
    return {
      requestReason: '',
      requestAmount: '',
      requestUser: {},
      payroll: Payroll,
      isManager: true,
      date: '',
      entries: [],
      requestSalaryAdvance: false,
      isSubmitting: false,
      licenceMessage: '',
      postResponseMessage: '',
      loadingLicence: false,
      allowsSalaryPaymentAdvance: false,
      salaryPaymentAdvance: false,
      cancelRequestSalaryAdvance: false,
    }
  },
  async created() {
    this.updateManagerStatus();
    this.payroll = new Payroll
    this.manager = new Manager();
  },
  mounted() {
    const inputElement = document.querySelector("input.vc-border-gray-400");
    if (inputElement) {
      inputElement.classList.remove("vc-border-gray-400");
      inputElement.classList.add("vc-border-gray-500");
      inputElement.classList.add('text-zt-dark-300')
    }
    this.$refs.datepicker.$children[0].$el.value = 'Fecha prevista'
  },
  computed: {
    isFormValid() {
      if (this.isManager) {
        return this.requestAmount && this.requestReason && this.date && this.requestUser.id;
      }
      else {
        return this.requestAmount && this.requestReason && this.date;
      }
    },
    errorClass() {
      switch (this.licenceMessage) {
        case 'info':
          return 'bg-certs-info';
        case 'error':
          return 'bg-certs-error';
        default:
          return 'no-errors';
      }
    },
    errorIcon() {
      switch (this.licenceMessage) {
        case 'info':
          return 'info';
        case 'error':
          return 'exclamation-circle-solid';
        default:
          return 'default-message';
      }
    },
    dateSelected() {
      return moment(this.date).format("YYYY-MM-DD")
    },
  },
  watch: {
    '$route': 'updateManagerStatus',
    date(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.$refs.datepicker.$children[0].$el.setAttribute('placeholder', 'Fecha prevista');
        });
      }
    }
  },
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    goBack() {
      this.hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    updateManagerStatus() {
      if (this.$route.query.isManager) {
        this.isManager = this.$route.query.isManager === 'true' && this.$store.state.user.perfiles
          .some(objeto => objeto.id_perfil_tipo === 8);
      }
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    async postRequest() {
      if (this.isSubmitting) {
        return;
      }
      this.postResponseMessage = "";
      this.isSubmitting = true;
      try {
        const data = {

          amount: this.requestAmount,
          plannedDate: this.dateSelected,
          reason: this.requestReason
        };
        const { amount, plannedDate, reason } = data

        this.isManager
          ? await this.payroll.requestUserSalaryAdvance(amount, plannedDate, reason, this.requestUser.id)
          : await this.payroll.requestSalaryAdvance(amount, plannedDate, reason);
        this.requestReason = ''
        this.requestAmount = ''
        this.date = ''
        this.requestUser = {}

        this.licenceMessage = 'info'
        this.postResponseMessage = 'La información se envío correctamente y espera aprobación'
        this.goBack()
      } catch (error) {
        this.postResponseMessage = this.customErrorMessges(error.response.data.codes)
        this.licenceMessage = 'error'
      }
      finally {
        this.isSubmitting = false;
      }
    },
    customErrorMessges(errorResponse) {
      const processErrorCode = ({ code, message }) => {
        if (code === "LICENSE_MANAGER_CREATE_ERROR") {
          return message;
        }
        const codesWithoutMessage = [
          "SICHERN_PEOPLE_EMPLOYEE_NOT_EXISTS",
          "SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST",
          "SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST",
        ];

        if (codesWithoutMessage.includes(code)) {
          return this.$t(`message.errorReference.${code}`);
        }
        if (/^SICHERN_PEOPLE_[A-Z_]+$/.test(code)) {
          if (/\s/.test(message)) {
            return this.$t(`message.errorReference.${code}`);
          }
          return this.$t(`message.errorReference.${code}_${message}`);
        }
        return this.$t(`message.errorReference.${code}`);
      };
      return errorResponse.map(processErrorCode)[0];
    },
    async searchApi(val) {
      if (val.length > 2) {
        this.salaryPaymentAdvance = false;
        this.allowsSalaryPaymentAdvance = false;
        const index = val.indexOf("(");
        try {
          if (index !== -1) {
            val = val.substring(0, index).trim();
          }
          const res = await this.manager.getTeamUsers(val);
          const entries = res.data.data;
          this.entries = entries.map((entry) => {
            let fullName = `${entry.name} (${entry.cuil})`;
            const text =
              fullName.length > this.descriptionLimit
                ? fullName.slice(0, this.descriptionLimit) + "..."
                : fullName;
            return { ...entry, text };
          });
        } catch (error) {
          this.entries = [];
        }
      }
    }
  },
}
</script>
<style scoped>
.bg-certs-info {
  background: #def3ff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #5b9cc2;
}
.bg-certs-error {
  background: #ffe2de 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #ffe2de;
}
.bg-certs-info>p {
  color: #017eec !important;
  opacity: 1 !important;
}
.bg-certs-error>p {
  color: #ec1101 !important;
  opacity: 1 !important;
}
.info-button {
  background: #def3ff 0% 0% no-repeat padding-box !important;
  opacity: 1;
}
.info-icon {
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
  max-width: 40px;
}
.zt-icon-info {
  color: #def3ff;
  background: #017eec;
}
.zt-icon-exclamation-circle-solid {
  font-size: x-large;
  color: red;
}
.error-icon {
  color: #def3ff;
  background: #ec1101;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
}
.shadowcustom {
  min-height: 48px;
  padding-top: 10px;
  padding-bottom: 12px;
  -webkit-box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}::v-deep .shadowcustom>.vc-py-2 {
  border-bottom: 0px solid !important;
}</style>